var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UpdateSeed } from "Server/Commands/UpdateSeed";
import { GetAttributes } from "Store/firebase/attributes";
import { Attribute } from "Store/firebase/attributes/@Attribute";
import { AttributeEditorUI } from "UI/Write/AttributeDetailsUI";
import { Button, CheckBox, Column, Pre, Row, RowLR, TextInput } from "react-vcomponents";
import { BaseComponentPlus } from "react-vextensions";
import { AddAttribute } from "../../Server/Commands/AddAttribute";
import { Slider, Observer } from "vwebapp-framework";
import { Clone } from "js-vextensions";
let SeedDetailsUI = class SeedDetailsUI extends BaseComponentPlus({}, {}) {
    render() {
        let { baseData, enabled, style } = this.props;
        const attributes = GetAttributes();
        let splitAt = 80, width = 230;
        return (React.createElement("div", null,
            " ",
            React.createElement(Column, { style: style },
                React.createElement(Row, { mt: 5 },
                    React.createElement(Pre, null,
                        "ID: ",
                        baseData._key)),
                React.createElement(RowLR, { mt: 5, splitAt: splitAt, style: { width } },
                    React.createElement(Pre, null, "Name: "),
                    React.createElement(TextInput, { required: true, delayChangeTillDefocus: true, enabled: enabled, style: { width: "100%" }, value: baseData.text, onChange: val => {
                            new UpdateSeed({ id: baseData._key, updates: { text: val } }).Run();
                        } })),
                React.createElement(Row, null,
                    React.createElement(Pre, null, "Attributes: "),
                    React.createElement(Button, { text: "+", onClick: () => {
                            let attribute = new Attribute({ name: "todo" });
                            new AddAttribute({ attribute }).Run();
                        } })),
                React.createElement(Column, null, attributes.map(attr => {
                    let hasAttribute = (baseData.attributeLevels || {})[attr._key] != null;
                    return (React.createElement(Column, { key: attr._key },
                        React.createElement(Row, null,
                            React.createElement(AttributeEditorUI, { mt: 5, attribute: attr })),
                        React.createElement(Row, { ml: 10, mr: 10, style: { width: 200 } },
                            React.createElement(Slider, { min: 0, max: 1, step: .1, enabled: hasAttribute, delayChangeTillDefocus: true, value: (baseData.attributeLevels || {})[attr._key], onChange: val => {
                                    let newAttributeLevels = Clone(baseData.attributeLevels || {});
                                    newAttributeLevels[attr._key] = val;
                                    new UpdateSeed({ id: baseData._key, updates: { attributeLevels: newAttributeLevels } }).Run();
                                } }),
                            React.createElement(CheckBox, { value: hasAttribute, onChange: val => {
                                    let newAttributeLevels = Clone(baseData.attributeLevels || {});
                                    if (val)
                                        newAttributeLevels[attr._key] = 0;
                                    else
                                        delete newAttributeLevels[attr._key];
                                    new UpdateSeed({ id: baseData._key, updates: { attributeLevels: newAttributeLevels } }).Run();
                                } }))));
                })))));
    }
};
SeedDetailsUI = __decorate([
    Observer
], SeedDetailsUI);
export { SeedDetailsUI };
